import * as earlyListingActions from '../../actions/early/earlyListing'
import * as h2Api from '../../h2Api'

const initialState = {
  games: []
}
const earlyListing = (state = initialState, action) => {
  switch (action.type) {
    case earlyListingActions.LIST_GAMES:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          games: action.restCall.result
        }
      }

      return state
    default:
      return state
  }
}

export default earlyListing
